import { renderWithResolver } from '@cinch-nx/landing-ui-shared'
import { StoryChargingAnEV } from '../../types/electric-cars-page'
import { Youtube } from '@cinch-labs/design-system'
import styles from './ev-charging.module.css'
import sharedStyles from '../../landing-feature-electric-cars.module.css'
import { Video, getStoryblokImageServiceUrl } from '@cinch-nx/data-storyblok'

interface EvChargingProps {
  evCharging: StoryChargingAnEV
}

interface VideoLinksSectionProps {
  firstText: StoryChargingAnEV['firstText']
  video: Video
  secondText: StoryChargingAnEV['secondText']
  links: StoryChargingAnEV['links']
}

const VideoLinksSection = ({
  firstText,
  video,
  secondText,
  links,
}: VideoLinksSectionProps) => {
  const { videoId, title: videoTitle, buttonLabel, thumbnail } = video
  return (
    <div>
      <h4 className={styles.largeText}>{firstText}</h4>
      <Youtube
        className={styles.video}
        videoId={videoId}
        title={videoTitle}
        buttonLabel={buttonLabel}
        customThumbnail={getStoryblokImageServiceUrl(thumbnail.filename, {
          filters: [{ quality: 80 }],
        })}
        videoUrlOptions={{ autoplay: 1 }}
        showNewPlayIcon
      />
      <h4 className={styles.largeText}>{secondText}</h4>
      <ul className={styles.linkList}>
        {links.map((link, index) => (
          <a
            key={`evLink-${index}`}
            href={link.url.url}
            className={styles.linkText}
          >
            {link.text}
          </a>
        ))}
      </ul>
    </div>
  )
}

export const EvCharging = ({ evCharging }: EvChargingProps) => {
  const { title, firstText, video, secondText, links, subtitle, text } =
    evCharging

  const textContent = renderWithResolver(text)
  return (
    <section>
      <h2 className={sharedStyles.heading}>{title}</h2>
      <VideoLinksSection
        firstText={firstText}
        video={video[0]}
        secondText={secondText}
        links={links}
      />

      <h3 className={styles.subheading}>{subtitle}</h3>
      <div className={sharedStyles.textContent}>{textContent}</div>
    </section>
  )
}
